import { useState, useEffect, useRef } from 'react';
import { ShoppingCart, Menu, X, Facebook, Instagram, Candy, Star, ChevronLeft, ChevronRight, ChevronDown, MessageCircle, Heart, Smile, Flower2, Pin, Check, Users } from 'lucide-react';
import { motion, AnimatePresence } from "framer-motion";
import { SiTiktok } from 'react-icons/si';
import dulceVideo from './Recursos/dulces.webm';
import Logo from './Recursos/logo.webp';
import ClubLogo from './Recursos/districlub-logo.webp';
import StoreLogo from './Recursos/store-logo.png';
import StoreLogoColor from './Recursos/store-logo-color.png';
import MascIcon from './Recursos/MASC.png';
import CajasReales from './Recursos/4anaF.webp';
import StaffAgus from './Recursos/staff/Agus Quipildor - Asesora comercial.jpeg';
import StaffDavor from './Recursos/staff/Davor Platero - Asesor comercial.jpeg';
import StaffErasmo from './Recursos/staff/Erasmo Castillo - Asesor comercial.jpeg';
import StaffExe from './Recursos/staff/Exe Contreras - Asesor comercial .jpeg';
import StaffGuillermo from './Recursos/staff/Guillermo Diaz Bueno - Asesor comercial Mayorista.jpeg';
import StaffMicaO from './Recursos/staff/Mica Olea - Asesora comercial.jpeg';
import StaffMicaR from './Recursos/staff/Mica Rodríguez - Directora administrativa.jpeg';
import StaffNadia from './Recursos/staff/Nadia González - Asesora comercial .jpeg';
import StaffStella from './Recursos/staff/Stella Barros - Supervisora General.jpeg';
import StaffYuli from './Recursos/staff/Yuli Contreras - Asesora comercial.jpeg';

const ConviDARComingSoonView = ({ onBack }) => (
  <div className="min-h-screen flex flex-col items-center justify-center p-4 relative overflow-hidden" style={{ backgroundColor: '#F5F1E8' }}>
    {/* Decorative Elements from the brand image */}
    <div className="absolute top-10 left-10 opacity-20 rotate-12">
      <div className="w-32 h-32 bg-[#FDB5A5] rounded-full blur-2xl" />
    </div>
    <div className="absolute bottom-20 right-10 opacity-20 -rotate-12">
      <div className="w-40 h-40 bg-[#94AD78] rounded-full blur-3xl" />
    </div>

    {/* Header Banner - Green (#94AD78) */}
    <div className="absolute top-0 left-0 right-0 h-40 bg-[#94AD78] -z-10 shadow-lg" />

    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className="max-w-3xl w-full bg-white rounded-[2.5rem] md:rounded-[4rem] p-6 md:p-16 shadow-[0_30px_60px_rgba(0,0,0,0.08)] text-center relative z-10 border border-[#94AD78]/10"
    >
      {/* Playful ConviDAR Logo Typography */}
      <div className="mb-12 relative inline-block">
        <h1 className="text-5xl sm:text-7xl md:text-9xl font-black tracking-tighter"
          style={{
            fontFamily: "'Fredoka One', cursive", // Playful substitute for Children One
            color: '#94AD78'
          }}>
          CONVI<span style={{ color: '#FDB5A5' }}>DAR</span>
        </h1>
        <div className="absolute -top-6 -right-10 text-[#94AD78] opacity-60">
          <Menu className="w-8 h-8 rotate-45" /> {/* Substitute for the marks */}
        </div>
        <p className="text-2xl font-bold mt-2" style={{ fontFamily: "'Inter', sans-serif", color: '#CE9B7E' }}>Distri Dulces™</p>
      </div>

      <div className="grid grid-cols-3 gap-4 mb-14 justify-items-center opacity-40">
        <div className="w-12 h-12 rounded-full flex items-center justify-center bg-[#94AD78] text-white">
          <Smile className="w-6 h-6" />
        </div>
        <div className="w-12 h-12 rounded-full flex items-center justify-center bg-[#FDB5A5] text-white">
          <Heart className="w-6 h-6" />
        </div>
        <div className="w-12 h-12 rounded-full flex items-center justify-center bg-[#CE9B7E] text-white">
          <Flower2 className="w-6 h-6" />
        </div>
      </div>

      <h2 className="text-3xl font-extrabold mb-6 text-gray-800" style={{ fontFamily: "'Inter', sans-serif" }}>
        Próximos Pasos en Nuestra Misión Solidaria
      </h2>

      <p className="text-xl text-gray-600 mb-12 leading-relaxed max-w-2xl mx-auto font-medium">
        Estamos adaptando nuestra sección solidaria con la nueva identidad de <span style={{ color: '#94AD78' }}>ConviDAR</span>. Muy pronto compartiremos nuevas formas de colaborar y sumar sonrisas.
      </p>

      <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
        <button
          onClick={onBack}
          className="bg-[#94AD78] text-white hover:bg-[#839b69] px-12 py-4 rounded-full font-black text-xl transition-all shadow-xl hover:scale-105"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Volver al Inicio
        </button>
        <div className="flex items-center gap-2 text-[#CE9B7E] font-bold text-lg italic">
          <Pin className="w-5 h-5" /> Muy pronto
        </div>
      </div>
    </motion.div>

    {/* Floating Elements Background */}
    <div className="absolute bottom-10 left-10 flex gap-4 opacity-30">
      <div className="w-8 h-8 rounded-full bg-[#FDB5A5]" />
      <div className="w-12 h-12 bg-[#94AD78] rotate-45 rounded-lg" />
    </div>

    <link href="https://fonts.googleapis.com/css2?family=Fredoka+One&family=Inter:wght@400;700;900&display=swap" rel="stylesheet" />
  </div>
);

// NUEVO COMPONENTE: FranquiciaComingSoonView
const FranquiciaComingSoonView = ({ onBack }) => (
  <div className="min-h-screen bg-gradient-to-br from-pink-400 via-purple-500 to-indigo-600 flex flex-col relative overflow-hidden font-sans">
    {/* Fondos y decoraciones animadas */}
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute top-10 left-10 w-64 h-64 bg-white/20 rounded-full blur-3xl animate-[pulse_4s_infinite]"></div>
      <div className="absolute bottom-10 right-10 w-80 h-80 bg-pink-300/20 rounded-full blur-3xl animate-[pulse_6s_infinite]"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-r from-pink-500/30 to-purple-500/30 rounded-full blur-[100px] animate-[spin_20s_linear_infinite]"></div>
    </div>

    {/* Header Navigation */}
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/10 backdrop-blur-md border-b border-white/20 shadow-lg">
      <div className="container mx-auto px-4 py-4 max-w-6xl flex justify-between items-center">
        <div className="flex items-center space-x-3 group cursor-pointer" onClick={onBack}>
          <div className="bg-white/20 group-hover:bg-white/30 p-2 rounded-full transition-all duration-300">
            <ChevronLeft className="w-6 h-6 text-white" />
          </div>
          <img src={Logo} alt="Volver a Distri Dulces" className="h-10 object-contain drop-shadow-md group-hover:drop-shadow-xl transition-all duration-300" />
          <span className="text-white font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300 -translate-x-2 group-hover:translate-x-0 hidden sm:block">
            Volver
          </span>
        </div>
      </div>
    </header>

    {/* Hero Content */}
    <div className="flex-grow flex flex-col items-center justify-center relative z-10 px-4 pt-24 pb-12">

      {/* Label superior */}
      <motion.div
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="mb-8"
      >
        <span className="px-6 py-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full text-white font-bold tracking-widest text-sm shadow-xl uppercase">
          Modelo de Negocios
        </span>
      </motion.div>

      {/* Main Titles */}
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="text-center max-w-4xl"
      >
        <h1 className="text-5xl md:text-7xl lg:text-8xl text-white mb-2 drop-shadow-2xl" style={{ fontFamily: "'Lemongrass Script', cursive", textShadow: '0 10px 30px rgba(0,0,0,0.3)' }}>
          Abrí tu propio...
        </h1>
        <motion.img
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          src={StoreLogo}
          alt="Distri Dulces STORE"
          className="h-32 md:h-48 lg:h-56 object-contain mx-auto mb-8 drop-shadow-2xl"
        />

        <p className="text-2xl md:text-3xl text-white/90 font-medium mb-12 max-w-3xl mx-auto leading-[1.8] drop-shadow-md">
          Sé parte de la familia líder en distribución de golosinas. <br className="hidden md:block" />
          Próximamente abriremos nuestro exclusivo sistema de <strong className="inline-block text-white bg-pink-500/40 px-4 py-1.5 rounded-xl shadow-sm transform translate-y-1">Franquicias</strong>.
        </p>

        {/* Feature badges */}
        <div className="flex flex-wrap justify-center gap-4 mb-14">
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-md px-5 py-3 rounded-full border border-white/20">
            <Star className="text-yellow-300 w-5 h-5" />
            <span className="text-white font-semibold">Alta rentabilidad</span>
          </div>
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-md px-5 py-3 rounded-full border border-white/20">
            <Smile className="text-pink-300 w-5 h-5" />
            <span className="text-white font-semibold">Respaldo total</span>
          </div>
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-md px-5 py-3 rounded-full border border-white/20">
            <Candy className="text-purple-300 w-5 h-5" />
            <span className="text-white font-semibold">Stock asegurado</span>
          </div>
        </div>

        {/* CTA Placeholder */}
        <div className="relative group mx-auto w-max">
          <div className="absolute -inset-1 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-tilt"></div>
          <button
            onClick={() => window.open('https://wa.me/5493813528236?text=Hola! Me interesa recibir información cuando abran el programa de franquicias.', '_blank')}
            className="relative px-8 md:px-12 py-5 bg-white rounded-full leading-none flex items-center shadow-2xl"
          >
            <span className="flex items-center">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-700 to-pink-600 font-black text-lg md:text-xl mr-3">
                Más información
              </span>
              <MessageCircle className="w-6 h-6 text-pink-500" />
            </span>
          </button>
        </div>
      </motion.div>
    </div>
  </div>
);

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [view, setView] = useState('home'); // 'home', 'coming_soon', 'club_benefits'
  const [isScrolled, setIsScrolled] = useState(false);
  const [isClubModalOpen, setIsClubModalOpen] = useState(false);
  const [clubModalType, setClubModalType] = useState('kiosco'); // 'kiosco' or 'mayorista'
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const carouselRef = useRef(null);
  const REAL_PRODUCTS_FALLBACK = [
    { id: 1313, name: "palitos chinos x60 und", category: "GOLOSINAS", categories: ["GOLOSINAS"], image: "https://store.distridulces.com.ar/wp-content/uploads/2026/07/palito-chino-x60-201x300.jpeg", permalink: "https://store.distridulces.com.ar/producto/palitos-chinos-x60-und/", price: "$ 13.200,00", description: "Bombillas azucaradas con muñeco 3D." },
    { id: 1311, name: "sour acido x30", category: "GOLOSINAS", categories: ["GOLOSINAS"], image: "https://store.distridulces.com.ar/wp-content/uploads/2026/07/sour-candy-x30.jpeg", permalink: "https://store.distridulces.com.ar/producto/sour-acido-x30/", price: "$ 10.900,00", description: "Caramelos ácidos variados." },
    { id: 1309, name: "caramelo en spray x24 und", category: "GOLOSINAS", categories: ["GOLOSINAS"], image: "https://store.distridulces.com.ar/wp-content/uploads/2026/07/caramelo-spray-x24.jpeg", permalink: "https://store.distridulces.com.ar/producto/caramelo-en-spray-x24-und/", price: "$ 7.200,00", description: "Caramelo líquido sabor frutal en spray." },
    { id: 1307, name: "gomita bigotes x30", category: "GOLOSINAS", categories: ["GOLOSINAS"], image: "https://store.distridulces.com.ar/wp-content/uploads/2026/07/gomita-bigotes-x30.jpeg", permalink: "https://store.distridulces.com.ar/producto/gomita-bigotes-x30/", price: "$ 9.800,00", description: "Gomitas masticables forma de bigotes." },
    { id: 1301, name: "chicle botella x30", category: "GOLOSINAS", categories: ["GOLOSINAS"], image: "https://store.distridulces.com.ar/wp-content/uploads/2026/07/botella-mariela-x30.jpeg", permalink: "https://store.distridulces.com.ar/producto/chicle-botella-x30/", price: "$ 7.200,00", description: "Chicle con forma de botella." },
    { id: 1299, name: "labial K-pop x30", category: "GOLOSINAS", categories: ["GOLOSINAS"], image: "https://store.distridulces.com.ar/wp-content/uploads/2026/07/labia-kpop.jpeg", permalink: "https://store.distridulces.com.ar/producto/1299/", price: "$ 9.800,00", description: "Golosina temática labial K-Pop." },
    { id: 1296, name: "huevo sorpresa sport x12", category: "GOLOSINAS", categories: ["GOLOSINAS"], image: "https://store.distridulces.com.ar/wp-content/uploads/2026/07/huevo-sport-toys-x12.jpeg", permalink: "https://store.distridulces.com.ar/producto/huevo-sorpresa-sport-x12/", price: "$ 10.900,00", description: "Huevo golosina sorpresa con juguete deportivo." },
    { id: 1294, name: "laser y reloj", category: "JUGUETES & VARIOS", categories: ["JUGUETES & VARIOS"], image: "https://store.distridulces.com.ar/wp-content/uploads/2026/07/plancha-reloj-mas-laser-x118.jpeg", permalink: "https://store.distridulces.com.ar/producto/laser-y-reloj/", price: "$ 26.200,00", description: "Plancha reloj más láser x118." },
    { id: 1292, name: "caramelo blando mamadera x30", category: "GOLOSINAS", categories: ["GOLOSINAS"], image: "https://store.distridulces.com.ar/wp-content/uploads/2026/07/mamadera-sugus-x30.jpeg", permalink: "https://store.distridulces.com.ar/producto/1292/", price: "$ 8.200,00", description: "Caramelo blando mamadera x30." },
    { id: 1290, name: "gummy ojitos 4D", category: "GOLOSINAS", categories: ["GOLOSINAS"], image: "https://store.distridulces.com.ar/wp-content/uploads/2026/07/gummy-ojitos-x30.jpeg", permalink: "https://store.distridulces.com.ar/producto/gummy-ojitos-4d/", price: "$ 6.000,00", description: "Gomita 4D ojitos rellenables." }
  ];
  const [categories, setCategories] = useState(["GOLOSINAS", "JUGUETES & VARIOS"]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('todos');
  const [catalogPage, setCatalogPage] = useState(1);
  const PRODUCTS_PER_PAGE = 6;
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    business: '',
    phone: '',
    message: ''
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const validateForm = () => {
    let errors = {};
    if (!formData.name.trim()) errors.name = 'El nombre es obligatorio';
    else if (!/^[a-zA-Z\s]+$/.test(formData.name)) errors.name = 'El nombre solo puede contener letras';

    if (!formData.email.trim()) errors.email = 'El correo es obligatorio';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) errors.email = 'El correo no es válido';

    if (!formData.phone.trim()) errors.phone = 'El teléfono es obligatorio';
    else if (!/^\d+$/.test(formData.phone)) errors.phone = 'El teléfono solo puede contener números';

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitting(true);
      try {
        // Here we simulate the form submission or use a service like Formspree
        // To make it functional, the user should replace the URL with their Formspree endpoint if needed
        // For now, we'll use a standard post to Formspree using the email provided
        const response = await fetch('https://formsubmit.co/ajax/distridulcesargentina@gmail.com', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            Nombre: formData.name,
            Email: formData.email,
            Negocio: formData.business,
            Telefono: formData.phone,
            Mensaje: formData.message,
            _subject: 'Nuevo mensaje de contacto - Distri Dulces'
          })
        });

        if (!response.ok) throw new Error('Error in submission');

        // Simulating success for the user as we don't have a real endpoint yet
        // but the email logic is defined.
        setSubmitSuccess(true);
        setFormData({ name: '', email: '', business: '', phone: '', message: '' });
      } catch (error) {
        console.error('Error submitting form:', error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };


  useEffect(() => {
    const fetchJson = async (path) => {
      const endpoints = [
        path,
        `https://store.distridulces.com.ar${path}`,
        `https://corsproxy.io/?url=${encodeURIComponent('https://store.distridulces.com.ar' + path)}`,
        `https://api.codetabs.com/v1/proxy?quest=${encodeURIComponent('https://store.distridulces.com.ar' + path)}`
      ];

      for (const url of endpoints) {
        try {
          const res = await fetch(url);
          if (res.ok) {
            const data = await res.json();
            if (data && (Array.isArray(data) ? data.length > 0 : true)) {
              return data;
            }
          }
        } catch (e) {
          // ignore and try next strategy
        }
      }
      return null;
    };

    const fetchStoreData = async () => {
      try {
        const [data, catData] = await Promise.all([
          fetchJson('/wp-json/wc/store/v1/products?per_page=100'),
          fetchJson('/wp-json/wc/store/v1/products/categories?per_page=100')
        ]);

        let formattedProducts = [];
        if (Array.isArray(data) && data.length > 0) {
          formattedProducts = data.map(p => {
            let imgSrc = p.images && p.images[0]?.src ? p.images[0].src : null;
            if (!imgSrc && p.description) {
              const match = p.description.match(/src=["']([^"']+)["']/i);
              if (match) imgSrc = match[1];
            }
            if (!imgSrc) imgSrc = 'https://via.placeholder.com/400';

            const catName = p.categories && p.categories[0]
              ? p.categories[0].name.replace(/&amp;/g, '&')
              : 'Golosinas';

            const catList = p.categories && p.categories.length > 0
              ? p.categories.map(c => c.name.replace(/&amp;/g, '&'))
              : [catName];

            let displayPrice = '';
            if (p.prices && p.prices.price) {
              const numPrice = parseFloat(p.prices.price) / (10 ** (p.prices.currency_minor_unit || 2));
              displayPrice = `$ ${numPrice.toLocaleString('es-AR', { minimumFractionDigits: 2 })}`;
            }

            return {
              id: p.id,
              name: p.name,
              category: catName,
              categories: catList,
              image: imgSrc,
              permalink: p.permalink,
              price: displayPrice,
              description: p.short_description ? p.short_description.replace(/<[^>]*>?/gm, '').trim() : ''
            };
          });

          setProducts(formattedProducts);
        }

        let fetchedCategories = [];
        if (Array.isArray(catData) && catData.length > 0) {
          fetchedCategories = catData
            .filter(c => c.count > 0 && c.slug !== 'uncategorized' && c.name.toLowerCase() !== 'sin categorizar')
            .map(c => c.name.replace(/&amp;/g, '&'));
        }

        if (fetchedCategories.length === 0 && formattedProducts.length > 0) {
          fetchedCategories = Array.from(new Set(formattedProducts.flatMap(p => p.categories).filter(Boolean)));
        }

        if (fetchedCategories.length > 0) {
          setCategories(fetchedCategories);
        }
      } catch (error) {
        console.error('Store API Error:', error);
      }
    };

    fetchStoreData();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [view]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100,
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const [products, setProducts] = useState(REAL_PRODUCTS_FALLBACK);

  // eslint-disable-next-line no-unused-vars
  const [club, setClub] = useState([
    { id: 1, title: '¿Qué andas buscando?😂', description: '¡Llegaron los alfajores de Ricky a DistriDulces! 🍬 Hace tu pedido y nosotros nos encargamos del resto.🙌', image: 'https://distridulces.com.ar/imagenes/riky.webp', color: 'from-pink-400 to-purple-500' },
    //{ id: 2, title: 'Promoción Especial Navidad', description: 'Compra 3 productos y lleva el cuarto gratis en toda nuestra línea de chocolates.', image: 'https://media.losandes.com.ar/p/7b5c87062edca409715aff25d4f47054/adjuntos/368/imagenes/100/002/0100002501/1000x0/smart/el-pan-dulce-es-una-las-preparaciones-protagonistas-la-mesa-dulce-navidad-y-ano-nuevo-foto-gentileza.png', color: 'from-purple-500 to-pink-400' },
    //{ id: 3, title: 'Lanzamiento Exclusivo', description: 'Prueba nuestras nuevas paletas artesanales con ingredientes naturales y sin conservantes.', image: 'https://cdn0.uncomo.com/es/posts/3/5/9/como_hacer_paletas_de_caramelo_36953_orig.jpg', color: 'from-pink-500 to-purple-600' },
  ]);



  const navItems = [
    { id: 'home', label: 'Inicio', scroll: true },
    { id: 'nuestro-mundo', label: 'Nuestro Mundo', scroll: false, dropdown: [
      { id: 'club-distridulces', label: 'Club DistriDulces', scroll: true },
      { id: 'familia-mayorista', label: 'Familia Mayorista', scroll: true },
      { id: 'catalog', label: 'Catálogo', scroll: true },
    ]},
    { id: 'franquicia', label: 'Abrí tu Distridulces', scroll: false },
    { id: 'nuestro-equipo', label: 'Nuestro Equipo', scroll: false },
    { id: 'convidar', label: 'ConviDAR', scroll: false },
    { id: 'contact', label: 'Contacto', scroll: true },
  ];


  const scrollToSection = (sectionId) => {
    let item = navItems.find(n => n.id === sectionId);
    if (!item) {
      for (const nav of navItems) {
        if (nav.dropdown) {
          item = nav.dropdown.find(sub => sub.id === sectionId);
          if (item) break;
        }
      }
    }
    if (!item || !item.scroll) return;
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setActiveSection(sectionId);
    setIsMenuOpen(false);
  };

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % club.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + club.length) % club.length);



  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-gradient-to-br from-pink-400 via-purple-500 to-pink-600 flex flex-col items-center justify-center z-50 overflow-hidden">
        <div className="absolute inset-0 animate-[gradientShift_6s_ease_infinite] bg-[length:200%_200%]"></div>
        <div className="relative z-10 flex flex-col items-center">
          <div className="relative w-40 h-40 flex items-center justify-center">
            <div className="absolute inset-0 rounded-full bg-white/20 blur-3xl"></div>
            <Candy className="w-20 h-20 text-white animate-[spin_4s_linear_infinite] drop-shadow-[0_0_15px_rgba(255,255,255,0.7)]" />
          </div>
          <div className="mt-10 relative w-24 h-24">
            <div className="absolute inset-0 border-4 border-white/20 rounded-full"></div>
            <div className="absolute inset-0 border-4 border-t-white/90 rounded-full animate-spin"></div>
          </div>
          <h1 className="mt-12 text-5xl md:text-6xl text-white drop-shadow-lg pb-4 animate-pulse" style={{ fontFamily: "'Lemongrass Script', cursive", lineHeight: 1.4 }}>Distri Dulces ™</h1>
          <p className="mt-4 text-white/90 text-xl animate-[shine_2s_ease-in-out_infinite]">Cargando tu experiencia dulce...</p>
        </div>
        <style>{`
          @keyframes gradientShift { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
          @keyframes shine { 0%,100% { opacity: 0.8; } 50% { opacity: 1; text-shadow: 0 0 15px rgba(255,255,255,0.8); } }
        `}</style>
      </div>
    );
  }

  return (
    <>
      {view === 'coming_soon' ? (
        <ComingSoonView onBack={() => setView('home')} />
      ) : view === 'club_kioscos_benefits' ? (
        <ClubBenefitsView type="kiosco" onBack={() => setView('home')} onJoinClick={() => { setClubModalType('kiosco'); setIsClubModalOpen(true); }} />
      ) : view === 'club_mayoristas_benefits' ? (
        <ClubBenefitsView type="mayorista" onBack={() => setView('home')} onJoinClick={() => { setClubModalType('mayorista'); setIsClubModalOpen(true); }} />
      ) : view === 'franquicia_coming_soon' ? (
        <FranquiciaComingSoonView onBack={() => setView('home')} />
      ) : view === 'convidar_coming_soon' ? (
        <ConviDARComingSoonView onBack={() => setView('home')} />
      ) : view === 'nuestro_equipo' ? (
        <NuestroEquipoView onBack={() => setView('home')} />
      ) : (
        <div className="font-sans overflow-x-hidden">
          <div className="fixed inset-0 pointer-events-none z-0">
            <div className="absolute top-20 left-10 w-32 h-32 bg-pink-200 rounded-full opacity-20 blur-xl"
              style={{ transform: `translate(${(mousePosition.x - 50) * 0.1}px, ${(mousePosition.y - 50) * 0.1}px)`, transition: 'transform 0.1s ease-out' }}></div>
            <div className="absolute bottom-20 right-10 w-40 h-40 bg-purple-200 rounded-full opacity-20 blur-xl"
              style={{ transform: `translate(${(mousePosition.x - 50) * -0.1}px, ${(mousePosition.y - 50) * -0.1}px)`, transition: 'transform 0.1s ease-out' }}></div>
          </div>

          <header className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-md transition-all duration-300 ${isScrolled ? 'bg-white/90 shadow-xl' : 'bg-transparent'}`}>
            <div className="container mx-auto px-4 py-2">
              <div className="flex justify-between items-center">
                <div className="flex items-center space-x-2">
                  <h1 className="text-2xl font-bold transition-all duration-300 flex" style={{ fontFamily: "'Lemongrass Script', cursive" }}>
                    <span style={{ color: isScrolled ? '#f2afd2' : '#ffffff', transition: 'color 0.4s ease' }} className="mr-2">Distri</span>
                    <span style={{ color: isScrolled ? '#8a85bc' : '#ffffff', transition: 'color 0.4s ease' }}>Dulces</span>
                    <span className={`text-sm tracking-tighter ml-1 ${isScrolled ? 'text-gray-400' : 'text-white/60'}`}>™</span>
                  </h1>
                </div>

                <nav className="hidden lg:flex space-x-4 xl:space-x-6 items-center">
                  {navItems.map((item) => (
                    item.dropdown ? (
                      <div
                        key={item.id}
                        className="relative"
                        onMouseEnter={() => setIsDropdownOpen(true)}
                        onMouseLeave={() => setIsDropdownOpen(false)}
                      >
                        <button
                          className={`capitalize transition-all duration-300 relative flex items-center gap-1 ${isScrolled ? 'text-gray-700 hover:text-purple-600 font-semibold' : 'text-white font-semibold hover:text-pink-200'}`}
                        >
                          {item.label}
                          <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${isDropdownOpen ? 'rotate-180' : ''}`} />
                        </button>
                        <AnimatePresence>
                          {isDropdownOpen && (
                            <motion.div
                              initial={{ opacity: 0, y: -10 }}
                              animate={{ opacity: 1, y: 0 }}
                              exit={{ opacity: 0, y: -10 }}
                              transition={{ duration: 0.2 }}
                              className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-56 bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-gray-100 py-2 overflow-hidden"
                            >
                              {item.dropdown.map((sub) => (
                                <button
                                  key={sub.id}
                                  onClick={() => {
                                    if (sub.scroll) scrollToSection(sub.id);
                                    setIsDropdownOpen(false);
                                  }}
                                  className="w-full text-left px-5 py-3 text-gray-700 hover:bg-gradient-to-r hover:from-pink-50 hover:to-purple-50 hover:text-purple-600 transition-all duration-200 font-medium text-sm"
                                >
                                  {sub.label}
                                </button>
                              ))}
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </div>
                    ) : (
                      <button
                        key={item.id}
                        onClick={() => {
                          if (item.id === 'convidar') {
                            setView('convidar_coming_soon');
                          } else if (item.id === 'franquicia') {
                            setView('franquicia_coming_soon');
                          } else if (item.id === 'nuestro-equipo') {
                            setView('nuestro_equipo');
                          } else if (item.scroll) {
                            scrollToSection(item.id);
                          }
                        }}
                        className={`capitalize transition-all duration-300 relative ${isScrolled ? (activeSection === item.id && item.scroll ? 'text-purple-600 font-semibold' : 'text-gray-700 hover:text-purple-600 font-semibold') : (activeSection === item.id && item.scroll ? 'text-white font-semibold' : 'text-white font-semibold hover:text-pink-200')}`}
                      >
                        {item.label}
                        {activeSection === item.id && item.scroll && (
                          <div className={`absolute -bottom-1 left-0 right-0 h-0.5 transition-all duration-300 ${isScrolled ? 'bg-purple-600' : 'bg-white'}`}></div>
                        )}
                      </button>
                    )
                  ))}
                </nav>

                <div className="flex items-center space-x-4">
                  <button
                    onClick={() => window.open('https://store.distridulces.com.ar/', '_blank')}
                    className="group relative transition-all duration-300 transform hover:scale-110 active:scale-95"
                    title="Ingresa a la Tienda Online"
                  >
                    <div className={`p-1 rounded-xl transition-all duration-300 ${isScrolled ? 'bg-transparent' : 'bg-white/10 backdrop-blur-sm'}`}>
                      <img
                        src={isScrolled ? StoreLogoColor : StoreLogo}
                        alt="Ingresar"
                        className="h-12 md:h-16 w-auto object-contain transition-all duration-500"
                      />
                    </div>
                  </button>

                  <button className={`lg:hidden transition-colors duration-300 ${isScrolled ? 'text-gray-700' : 'text-white'}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    {isMenuOpen ? <X className="w-8 h-8" /> : <Menu className="w-8 h-8" />}
                  </button>
                </div>
              </div>
            </div>

            {isMenuOpen && (
              <div className={`lg:hidden ${isScrolled ? 'bg-white' : 'bg-gray-900 bg-opacity-95'} border-t ${isScrolled ? 'border-gray-200' : 'border-gray-700'} backdrop-blur-sm`}>
                <div className="container mx-auto px-4 py-4 flex flex-col space-y-2">
                  {navItems.map((item) => (
                    item.dropdown ? (
                      <div key={item.id}>
                        <button
                          onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
                          className={`capitalize py-2 w-full text-left flex items-center justify-between transition-all duration-300 ${isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-pink-200'}`}
                        >
                          {item.label}
                          <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${mobileDropdownOpen ? 'rotate-180' : ''}`} />
                        </button>
                        {mobileDropdownOpen && (
                          <div className="pl-4 border-l-2 border-pink-300 ml-2 mt-1 space-y-1">
                            {item.dropdown.map((sub) => (
                              <button
                                key={sub.id}
                                onClick={() => {
                                  if (sub.scroll) scrollToSection(sub.id);
                                  setIsMenuOpen(false);
                                  setMobileDropdownOpen(false);
                                }}
                                className={`block py-2 capitalize transition-all duration-300 text-sm ${isScrolled ? 'text-gray-600 hover:text-purple-600' : 'text-white/80 hover:text-white'}`}
                              >
                                {sub.label}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    ) : (
                      <button
                        key={item.id}
                        onClick={() => {
                          if (item.id === 'convidar') {
                            setView('convidar_coming_soon');
                            setIsMenuOpen(false);
                          } else if (item.id === 'franquicia') {
                            setView('franquicia_coming_soon');
                            setIsMenuOpen(false);
                          } else if (item.id === 'nuestro-equipo') {
                            setView('nuestro_equipo');
                            setIsMenuOpen(false);
                          } else if (item.scroll) {
                            scrollToSection(item.id);
                          } else {
                            setIsMenuOpen(false);
                          }
                        }}
                        className={`capitalize py-2 transition-all duration-300 relative text-left ${isScrolled ? (activeSection === item.id && item.scroll ? 'text-purple-600' : 'text-gray-700 hover:text-purple-600') : (activeSection === item.id && item.scroll ? 'text-white' : 'text-white hover:text-pink-200')}`}
                      >
                        {item.label}
                        {activeSection === item.id && item.scroll && (
                          <div className={`absolute -bottom-1 left-0 right-0 h-0.5 transition-all duration-300 ${isScrolled ? 'bg-purple-600' : 'bg-white'}`}></div>
                        )}
                      </button>
                    )
                  ))}
                </div>
              </div>
            )}
          </header>

          <main>
            <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 md:pt-0">
              <video className="absolute inset-0 w-full h-full object-cover" src={dulceVideo} autoPlay loop muted playsInline preload="auto" />
              <div className="absolute inset-0 bg-gradient-to-br from-pink-400 via-purple-500 to-pink-600 opacity-80"></div>
              <div className="absolute inset-0 opacity-40">
                <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full -translate-x-1/2 -translate-y-1/2 opacity-30 blur-2xl"></div>
                <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/2 translate-y-1/2 opacity-30 blur-2xl"></div>
                <div className="absolute top-1/2 right-0 w-64 h-64 bg-white rounded-full translate-x-1/2 -translate-y-1/2 opacity-20 blur-xl"></div>
              </div>

              <div className="container mx-auto px-4 relative z-10 text-center">
                <div className="mb-8 transform hover:scale-105 transition-transform duration-500" style={{ transform: `translate(${(mousePosition.x - 50) * 0.2}px, ${(mousePosition.y - 50) * 0.2}px)`, transition: "transform 0.2s ease-out" }}>
                  <div className="inline-block p-5 bg-white/25 backdrop-blur-sm rounded-full shadow-2xl mb-6 animate-pulse">
                    <img src={Logo} alt="Logo de Distri Dulces — Distribuidora de Golosinas" className="w-20 h-20 object-contain drop-shadow-[0_0_10px_rgba(255,255,255,0.6)] animate-[float_4s_ease-in-out_infinite]" />
                  </div>

                  <h2 className="text-6xl md:text-8xl text-white mb-6 drop-shadow-2xl" style={{ fontFamily: "'Lemongrass Script', cursive" }}>Distri Dulces</h2>

                  {/* subtítulo mejorado para mayor contraste */}
                  <p className="text-2xl md:text-3xl font-semibold mb-10 max-w-2xl mx-auto drop-shadow-xl" style={{ textShadow: '0 6px 20px rgba(0,0,0,0.45)' }}>
                    <span style={{ background: 'linear-gradient(90deg, #FFB0C9 0%, #FFB0C9 40%, #FFB0C9 80%)', WebkitBackgroundClip: 'text', color: 'transparent', fontWeight: 700 }}>
                      La distribuidora favorita de los niños
                    </span>
                  </p>

                  <div className="flex flex-col sm:flex-row gap-6 justify-center">
                    <button onClick={() => scrollToSection("catalog")} className="bg-white text-pink-600 hover:bg-pink-50 px-10 py-4 rounded-full transition-all duration-300 text-lg font-bold shadow-2xl hover:shadow-3xl transform hover:scale-105">Ver Catálogo</button>
                    <button onClick={() => scrollToSection("club-distridulces")} className="border-2 border-white text-white hover:bg-white hover:bg-opacity-20 px-10 py-4 rounded-full transition-all duration-300 text-lg font-bold shadow-2xl hover:shadow-3xl transform hover:scale-105">Club DistriDulces</button>
                  </div>
                </div>
              </div>
            </section>

            {/* CLUB DISTRIDULCES */}
            <section id="club-distridulces" className="py-20 relative overflow-hidden bg-gradient-to-br from-pink-100 via-white to-blue-100">
              {/* Fondos decorativos suaves */}
              <div className="absolute -left-40 top-8 w-96 h-96 rounded-full opacity-60 blur-3xl" style={{ background: 'radial-gradient(circle,#ff9ac7,#ffd1f0)' }} aria-hidden />
              <div className="absolute -right-40 bottom-8 w-96 h-96 rounded-full opacity-50 blur-3xl" style={{ background: 'radial-gradient(circle,#cfe1ff,#e6f0ff)' }} aria-hidden />

              <div className="container mx-auto px-4 relative z-10">
                {/* Header */}
                <div className="text-center mb-12 transition-transform duration-500">
                  {/* Logo + título */}
                  <div className="flex flex-col md:flex-row items-center justify-center gap-5">
                    {/* Logo animado */}
                    <motion.div
                      initial={{ scale: 0.8, opacity: 0 }}
                      whileInView={{ scale: 1, opacity: 1 }}
                      transition={{ type: 'spring', stiffness: 120 }}
                      className="w-24 h-24 flex items-center justify-center"
                    >
                      <img
                        src={ClubLogo}
                        alt="Logo Club Distridulces"
                        className="w-full h-auto drop-shadow-xl logo-float"
                      />
                    </motion.div>

                    <motion.div
                      initial={{ y: 8, opacity: 0 }}
                      whileInView={{ y: 0, opacity: 1 }}
                      transition={{ duration: 0.5 }}
                      className="text-center md:text-center"
                    >
                      {/* Título con fuente Lemongrass */}
                      <h2
                        className="text-6xl text-gray-800 mb-2 tracking-tight "
                        style={{ fontFamily: 'Lemongrass Script', lineHeight: 1.1 }}
                      >
                        Club DistriDulces
                      </h2>

                      {/* Subtítulo con fuente del sistema */}
                      <p
                        className="mt-2 text-xl text-gray-600 max-w-2xl mx-auto"
                        style={{
                          fontFamily:
                            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                        }}
                      >
                        Sumate al club de los que siempre ganan. Descuentos, combos pensados para tu negocio y beneficios exclusivos para nuestros clientes.
                      </p>
                    </motion.div>
                  </div>

                  {/* Contadores */}
                  <div className="mt-8 flex justify-center items-center gap-8 md:gap-16 flex-wrap">
                    <div className="text-center min-w-[140px]">
                      <div className="text-3xl md:text-4xl font-bold text-pink-500 transition-all duration-300">+150</div>
                      <div className="mt-1 text-base md:text-xl text-gray-800 font-semibold">Comercios adheridos</div>
                    </div>
                    <div className="text-center min-w-[140px]">
                      <div className="text-3xl md:text-4xl font-bold text-pink-500 transition-all duration-300">Hasta 30%</div>
                      <div className="mt-1 text-base md:text-xl text-gray-800 font-semibold">Descuentos exclusivos</div>
                    </div>
                  </div>
                </div>

                <div className="relative max-w-6xl mx-auto">
                  <div
                    ref={carouselRef}
                    className="relative h-[560px] md:h-[520px] overflow-hidden rounded-3xl shadow-2xl"
                    style={{
                      perspective: 1000,
                      transform: `perspective(1000px) rotateX(${(mousePosition.y - 50) * 0.02}deg) rotateY(${(mousePosition.x - 50) * 0.02}deg)`,
                    }}
                  >
                    {club.map((promo, index) => (
                      <motion.div
                        key={promo.id}
                        initial={{ opacity: 0, x: 30 }}
                        animate={index === currentSlide ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
                        transition={{ duration: 0.5 }}
                        className={`absolute inset-0 transition-all duration-700 ease-in-out transform ${index === currentSlide ? 'z-10' : 'z-0'
                          }`}
                      >
                        {/* Imagen de fondo con filtro rosa brillante */}
                        <div className="absolute inset-0 bg-pink-100/30 mix-blend-multiply z-10 pointer-events-none" />
                        <div className="absolute inset-0 bg-gradient-to-t from-pink-500/50 via-pink-400/20 to-transparent z-10 pointer-events-none" />
                        <img
                          src={promo.image}
                          alt={`Promoción Club Distri Dulces: ${promo.title}`}
                          className="w-full h-full object-cover relative z-0"
                        />

                        {/* Tarjeta de promoción */}
                        <div className="absolute left-6 right-6 md:left-16 md:w-1/2 md:right-auto bottom-8 z-20">
                          <div className="bg-white/65 p-6 md:p-8 rounded-2xl shadow-lg">
                            <span className="inline-block mb-3 px-3 py-1 rounded-full text-sm font-semibold bg-pink-100 text-pink-600">
                              Lanzamiento exclusivo
                            </span>
                            <h3 className="text-2xl md:text-3xl font-bold text-blue-700 mb-3">{promo.title}</h3>
                            <p className="text-gray-700 mb-6">{promo.description}</p>
                            <div className="flex flex-col sm:flex-row gap-4 mt-2">
                              <button
                                onClick={() => setView('club_kioscos_benefits')}
                                className="w-full sm:w-auto px-8 py-3 rounded-full bg-gradient-to-r from-pink-500 to-pink-600 text-white font-bold shadow-md hover:scale-105 transition-transform text-center"
                              >
                                Ver beneficios
                              </button>
                              <div className="w-full sm:w-auto">
                                <ClubJoinButton onClick={() => { setClubModalType('kiosco'); setIsClubModalOpen(true); }} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    ))}
                  </div>

                  {/* Controles del carrusel */}
                  <button
                    onClick={prevSlide}
                    className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/30 backdrop-blur-sm p-3 rounded-full shadow hover:scale-110 transition"
                  >
                    <ChevronLeft className="w-5 h-5 text-gray-700" />
                  </button>
                  <button
                    onClick={nextSlide}
                    className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/30 backdrop-blur-sm p-3 rounded-full shadow hover:scale-110 transition"
                  >
                    <ChevronRight className="w-5 h-5 text-gray-700" />
                  </button>

                  {/* Indicadores */}
                  <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-3 z-20">
                    {club.map((_, i) => (
                      <button
                        key={i}
                        onClick={() => setCurrentSlide(i)}
                        className={`w-3 h-3 rounded-full transition ${i === currentSlide ? 'scale-125' : ''}`}
                        style={{ background: i === currentSlide ? '#FF409B' : 'rgba(255,255,255,0.7)' }}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </section>

            {/* FAMILIA MAYORISTA */}
            <section id="familia-mayorista" className="py-20 relative overflow-hidden bg-gradient-to-br from-[#F0EDFF] via-white to-[#FFEEF5]">
              <div className="absolute -left-40 top-8 w-96 h-96 rounded-full opacity-60 blur-3xl" style={{ background: 'radial-gradient(circle,#8A7CC7,#C5B9F3)' }} aria-hidden />
              <div className="absolute -right-40 bottom-8 w-96 h-96 rounded-full opacity-50 blur-3xl" style={{ background: 'radial-gradient(circle,#FF8BB2,#FFEEF5)' }} aria-hidden />

              <div className="container mx-auto px-4 relative z-10">
                <div className="text-center mb-12">
                  <div className="flex flex-col md:flex-row items-center justify-center gap-5">
                    <motion.div
                      initial={{ scale: 0.8, opacity: 0 }}
                      whileInView={{ scale: 1, opacity: 1 }}
                      transition={{ type: 'spring', stiffness: 120 }}
                      className="w-24 h-24 flex items-center justify-center"
                    >
                      <div className="w-full h-full bg-[#8A7CC7] rounded-2xl flex items-center justify-center shadow-xl transform -rotate-3 hover:rotate-0 transition-transform duration-500">
                        <Star className="w-12 h-12 text-white fill-current" />
                      </div>
                    </motion.div>

                    <motion.div
                      initial={{ y: 8, opacity: 0 }}
                      whileInView={{ y: 0, opacity: 1 }}
                      transition={{ duration: 0.5 }}
                    >
                      <h2
                        className="text-6xl text-gray-800 mb-2 pb-3 tracking-tight"
                        style={{ fontFamily: 'Lemongrass Script', lineHeight: 1.3 }}
                      >
                        Familia Mayorista
                      </h2>
                      <p className="mt-2 text-xl text-gray-600 max-w-2xl mx-auto">
                        Creamos alianzas estratégicas con distribuidores regionales para posicionar productos y potenciar mayoristas.
                      </p>
                    </motion.div>
                  </div>

                  <div className="mt-8 flex justify-center items-center gap-8 md:gap-16 flex-wrap">
                    <div className="text-center min-w-[140px]">
                      <div className="text-3xl md:text-4xl font-bold text-[#8A7CC7]">50+</div>
                      <div className="mt-1 text-base md:text-xl text-gray-800 font-semibold">Grandes Clientes</div>
                    </div>
                    <div className="text-center min-w-[140px]">
                      <div className="text-3xl md:text-4xl font-bold text-[#FF8BB2]">Propia</div>
                      <div className="mt-1 text-base md:text-xl text-gray-800 font-semibold">Logística Regional</div>
                    </div>
                  </div>
                </div>

                <div className="max-w-6xl mx-auto">
                  <div className="bg-white/80 backdrop-blur-md p-8 md:p-12 rounded-[3.5rem] shadow-2xl border border-purple-50 flex flex-col md:flex-row items-center gap-12">
                    <div className="md:w-1/2">
                      <h3 className="text-4xl font-black text-[#5B4E99] mb-8 leading-tight">Potenciá tu distribución</h3>
                      <ul className="space-y-5 mb-10">
                        {[
                          'Precios competitivos por volumen (bulto y pallet)',
                          'Atención prioritaria B2B',
                          'Lanzamientos exclusivos',
                          'Financiamiento a medida',
                          'Llegamos a todo el país'
                        ].map((item, i) => (
                          <li key={i} className="flex items-center gap-4 text-gray-700 text-lg font-semibold">
                            <div className="w-7 h-7 bg-[#FFEEF5] rounded-full flex items-center justify-center shrink-0">
                              <Check className="w-4 h-4 text-[#FF8BB2]" />
                            </div>
                            {item}
                          </li>
                        ))}
                      </ul>
                      <div className="flex flex-col sm:flex-row gap-5">
                        <button
                          onClick={() => setView('club_mayoristas_benefits')}
                          className="px-10 py-4 rounded-full bg-[#8A7CC7] text-white font-bold shadow-xl hover:bg-[#7466B1] transition-all transform hover:scale-105"
                        >
                          Ver Beneficios
                        </button>
                        <ClubJoinButton text="¡Quiero unirme a la familia!" onClick={() => { setClubModalType('mayorista'); setIsClubModalOpen(true); }} />
                      </div>
                    </div>
                    <div className="md:w-1/2 relative mt-12 md:mt-0">
                      <div className="min-h-[360px] md:aspect-[4/3] bg-gradient-to-tr from-[#8A7CC7] to-[#FF8BB2] rounded-[3rem] shadow-2xl overflow-hidden flex flex-col items-center justify-center p-8 md:p-12 transform rotate-2 hover:rotate-0 transition-all duration-700">
                        <div className="text-center w-full">
                          <img src={CajasReales} alt="Merchandising Mayorista" className="w-[85%] max-w-[200px] h-auto md:h-56 mx-auto mb-6 object-cover transform hover:scale-105 transition-all duration-500 rounded-bl-[3rem] drop-shadow-[0_15px_15px_rgba(0,0,0,0.3)] shrink-0" />
                          <div className="text-white text-2xl md:text-3xl font-black tracking-widest opacity-90 uppercase leading-snug break-words">Venta<br className="md:hidden" /> Mayorista</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* ====================== CATÁLOGO Y COLECCIÓN DE PRODUCTOS ====================== */}
            <section
              id="catalog"
              className="py-24 bg-[#f8fafc] relative overflow-hidden"
            >
              {/* Fondos decorativos muy sutiles para minimalismo */}
              <div className="absolute inset-0 opacity-[0.03]">
                <div className="absolute top-20 left-20 w-64 h-64 bg-indigo-500 rounded-full blur-3xl"></div>
                <div className="absolute bottom-20 right-20 w-80 h-80 bg-pink-500 rounded-full blur-3xl"></div>
              </div>

              <div className="container mx-auto px-4 relative z-10">
                {/* 1️⃣ TÍTULO */}
                <div className="text-center mb-12">
                  <h2
                    className="text-6xl text-gray-800 mb-4"
                    style={{ fontFamily: "'Lemongrass Script', cursive" }}
                  >
                    Catálogo y Colección de Productos
                  </h2>
                  <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                    Explorá nuestros catálogos personalizados según tu tipo de negocio
                  </p>
                </div>

                {/* 2️⃣ BOTONES DE CATEGORÍAS */}
                <div className="flex flex-wrap justify-center gap-3 mb-10 max-w-5xl mx-auto">
                  <motion.button
                    key="todos"
                    onClick={() => { setSelectedCategory("todos"); setCatalogPage(1); }}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.98 }}
                    className={`px-6 py-3 rounded-full text-sm sm:text-base font-semibold transition-all duration-300 border ${selectedCategory === "todos"
                      ? "bg-gradient-to-r from-pink-400 to-indigo-500 text-white border-transparent shadow-[0_8px_20px_-6px_rgba(99,102,241,0.5)]"
                      : "bg-white text-slate-600 border-slate-200 hover:text-indigo-600 hover:border-indigo-300 hover:shadow-md"
                      }`}
                  >
                    Todas las categorías
                  </motion.button>
                  {categories.map((catName) => (
                    <motion.button
                      key={catName}
                      onClick={() => { setSelectedCategory(catName); setCatalogPage(1); }}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.98 }}
                      className={`px-6 py-3 rounded-full text-sm sm:text-base font-semibold transition-all duration-300 border ${selectedCategory === catName
                        ? "bg-gradient-to-r from-pink-400 to-indigo-500 text-white border-transparent shadow-[0_8px_20px_-6px_rgba(99,102,241,0.5)]"
                        : "bg-white text-slate-600 border-slate-200 hover:text-indigo-600 hover:border-indigo-300 hover:shadow-md"
                        }`}
                    >
                      {catName}
                    </motion.button>
                  ))}
                </div>

                {/* 3️⃣ FILTRO DESPLEGABLE */}
                <div className="flex justify-center mb-16">
                  <motion.div whileHover={{ scale: 1.02 }} className="relative w-full max-w-xs">
                    <select
                      value={selectedCategory}
                      onChange={(e) => { setSelectedCategory(e.target.value); setCatalogPage(1); }}
                      className="w-full appearance-none bg-white border-2 border-slate-200 text-slate-700 font-medium rounded-full px-6 py-3 shadow-sm focus:outline-none focus:ring-4 focus:ring-indigo-500/10 focus:border-indigo-400 transition-all duration-300 cursor-pointer text-center"
                    >
                      <option value="todos">Todas las categorías</option>
                      {categories.map((catName) => (
                        <option key={catName} value={catName}>
                          {catName}
                        </option>
                      ))}
                    </select>

                    {/* ícono decorativo */}
                    <div className="pointer-events-none absolute right-5 top-1/2 -translate-y-1/2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 text-pink-500"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                  </motion.div>
                </div>

                {/* 4️⃣ CATÁLOGO FILTRABLE */}
                <AnimatePresence mode="wait">
                  <motion.div
                    key={selectedCategory + '-' + catalogPage}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 0.4 }}
                  >
                    {(() => {
                      const filtered = products.filter((p) => {
                        if (selectedCategory === "todos") return true;
                        if (Array.isArray(p.categories) && p.categories.length > 0) {
                          return p.categories.includes(selectedCategory);
                        }
                        return p.category === selectedCategory;
                      });
                      const totalPages = Math.ceil(filtered.length / PRODUCTS_PER_PAGE);
                      const paginated = filtered.slice((catalogPage - 1) * PRODUCTS_PER_PAGE, catalogPage * PRODUCTS_PER_PAGE);

                      return (
                        <>
                          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
                            {paginated.map((product) => (
                              <motion.div
                                key={product.id}
                                whileHover={{ y: -8 }}
                                className="bg-white rounded-[1.5rem] shadow-lg hover:shadow-[0_20px_40px_-10px_rgba(0,0,0,0.1)] border border-slate-100 overflow-hidden transition-all duration-300 group"
                              >
                                 <div className="relative overflow-hidden bg-slate-50 h-64 flex items-center justify-center p-4">
                                  <img
                                    src={product.image}
                                    alt={product.name}
                                    className="max-h-full max-w-full object-contain group-hover:scale-105 transition-transform duration-700"
                                  />
                                  <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm text-indigo-600 px-3.5 py-1 rounded-full text-xs font-bold shadow-sm border border-slate-100 uppercase">
                                    {product.category}
                                  </div>
                                  {product.price && (
                                    <div className="absolute top-4 right-4 bg-gradient-to-r from-pink-500 to-indigo-600 text-white px-3 py-1 rounded-full text-xs font-extrabold shadow-md">
                                      {product.price}
                                    </div>
                                  )}
                                </div>
                                <div className="p-6">
                                  <h3 className="text-xl font-bold text-slate-800 mb-2 group-hover:text-indigo-600 transition-colors duration-300 capitalize">
                                    {product.name}
                                  </h3>
                                  <p className="text-slate-500 mb-6 text-xs leading-relaxed line-clamp-2">
                                    {product.description || 'Disponible para venta y distribución inmediata en nuestra tienda.'}
                                  </p>
                                  <a
                                    href={product.permalink || `https://store.distridulces.com.ar/`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block w-full text-center bg-slate-100 hover:bg-gradient-to-r hover:from-pink-400 hover:to-indigo-500 hover:text-white text-slate-700 px-6 py-3 rounded-full transition-all duration-300 font-semibold text-sm shadow-sm hover:shadow-lg transform active:scale-95"
                                  >
                                    Comprar en la Tienda
                                  </a>
                                </div>
                              </motion.div>
                            ))}
                          </div>

                          {/* PAGINADO */}
                          {totalPages > 1 && (
                            <div className="flex justify-center items-center gap-2 mt-12">
                              <motion.button
                                onClick={() => setCatalogPage(p => Math.max(1, p - 1))}
                                disabled={catalogPage === 1}
                                whileHover={{ scale: catalogPage === 1 ? 1 : 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                className={`w-10 h-10 rounded-full flex items-center justify-center font-bold transition-all duration-300 border ${
                                  catalogPage === 1
                                    ? 'bg-slate-100 text-slate-300 border-slate-200 cursor-not-allowed'
                                    : 'bg-white text-slate-600 border-slate-200 hover:border-indigo-400 hover:text-indigo-600 shadow-sm hover:shadow-md'
                                }`}
                              >
                                ‹
                              </motion.button>

                              {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                                <motion.button
                                  key={page}
                                  onClick={() => setCatalogPage(page)}
                                  whileHover={{ scale: 1.1 }}
                                  whileTap={{ scale: 0.95 }}
                                  className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-300 border ${
                                    catalogPage === page
                                      ? 'bg-gradient-to-r from-pink-400 to-indigo-500 text-white border-transparent shadow-[0_4px_14px_-4px_rgba(99,102,241,0.5)]'
                                      : 'bg-white text-slate-600 border-slate-200 hover:border-indigo-400 hover:text-indigo-600 shadow-sm hover:shadow-md'
                                  }`}
                                >
                                  {page}
                                </motion.button>
                              ))}

                              <motion.button
                                onClick={() => setCatalogPage(p => Math.min(totalPages, p + 1))}
                                disabled={catalogPage === totalPages}
                                whileHover={{ scale: catalogPage === totalPages ? 1 : 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                className={`w-10 h-10 rounded-full flex items-center justify-center font-bold transition-all duration-300 border ${
                                  catalogPage === totalPages
                                    ? 'bg-slate-100 text-slate-300 border-slate-200 cursor-not-allowed'
                                    : 'bg-white text-slate-600 border-slate-200 hover:border-indigo-400 hover:text-indigo-600 shadow-sm hover:shadow-md'
                                }`}
                              >
                                ›
                              </motion.button>
                            </div>
                          )}
                        </>
                      );
                    })()}
                  </motion.div>
                </AnimatePresence>
              </div>
            </section>

            {/* CONTACT: reorganizado para dos filas de dos columnas */}
            <section id="contact" className="py-20 bg-white relative overflow-hidden">
              <div className="absolute inset-0 opacity-5">
                <div className="absolute top-32 left-32 w-24 h-24 bg-pink-200 rounded-full blur-xl"></div>
                <div className="absolute bottom-32 right-32 w-32 h-32 bg-purple-200 rounded-full blur-xl"></div>
              </div>

              <div className="container mx-auto px-4 relative z-10">
                <div className="text-center mb-16">
                  <h2 className="text-6xl text-gray-800 mb-4" style={{ fontFamily: "'Lemongrass Script', cursive" }}>Contáctanos</h2>
                  <p className="text-xl text-gray-600 max-w-2xl mx-auto">Completa el formulario y uno de nuestros representantes se pondrá en contacto contigo</p>
                </div>

                <div className="max-w-3xl mx-auto">
                  <form onSubmit={handleSubmit} className="bg-white p-10 rounded-2xl shadow-2xl" style={{ transform: `translate(${(mousePosition.x - 50) * 0.1}px, ${(mousePosition.y - 50) * 0.1}px)`, transition: 'transform 0.2s ease-out' }}>
                    {submitSuccess && (
                      <div className="mb-6 p-4 bg-green-100 text-green-700 rounded-xl text-center font-bold">
                        ¡Gracias! Tu mensaje ha sido enviado correctamente.
                      </div>
                    )}
                    {/* FILA 1: Nombre completo | Correo electrónico */}
                    <div className="grid md:grid-cols-2 gap-8 mb-8">
                      <div>
                        <label className="block text-gray-700 mb-3 text-lg font-medium">Nombre completo</label>
                        <input
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          type="text"
                          className={`w-full px-5 py-4 border-2 rounded-xl focus:ring-3 focus:ring-purple-500 focus:border-purple-500 transition-all duration-300 text-lg ${formErrors.name ? 'border-red-500' : 'border-gray-200'}`}
                          placeholder="Tu nombre completo"
                        />
                        {formErrors.name && <p className="mt-2 text-red-500 text-sm">{formErrors.name}</p>}
                      </div>

                      <div>
                        <label className="block text-gray-700 mb-3 text-lg font-medium">Correo electrónico</label>
                        <input
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          type="email"
                          className={`w-full px-5 py-4 border-2 rounded-xl focus:ring-3 focus:ring-purple-500 focus:border-purple-500 transition-all duration-300 text-lg ${formErrors.email ? 'border-red-500' : 'border-gray-200'}`}
                          placeholder="tu@email.com"
                        />
                        {formErrors.email && <p className="mt-2 text-red-500 text-sm">{formErrors.email}</p>}
                      </div>
                    </div>

                    {/* FILA 2: Nombre del negocio | Teléfono */}
                    <div className="grid md:grid-cols-2 gap-8 mb-8">
                      <div>
                        <label className="block text-gray-700 mb-3 text-lg font-medium">Nombre del negocio</label>
                        <input
                          name="business"
                          value={formData.business}
                          onChange={handleInputChange}
                          type="text"
                          className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:ring-3 focus:ring-purple-500 focus:border-purple-500 transition-all duration-300 text-lg"
                          placeholder="Ej: Dulces La Esquina"
                        />
                      </div>

                      <div>
                        <label className="block text-gray-700 mb-3 text-lg font-medium">Teléfono</label>
                        <input
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          type="tel"
                          className={`w-full px-5 py-4 border-2 rounded-xl focus:ring-3 focus:ring-purple-500 focus:border-purple-500 transition-all duration-300 text-lg ${formErrors.phone ? 'border-red-500' : 'border-gray-200'}`}
                          placeholder="+54 381 123-4567"
                        />
                        {formErrors.phone && <p className="mt-2 text-red-500 text-sm">{formErrors.phone}</p>}
                      </div>
                    </div>

                    <div className="mb-8">
                      <label className="block text-gray-700 mb-3 text-lg font-medium">Mensaje</label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        rows="6"
                        className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:ring-3 focus:ring-purple-500 focus:border-purple-500 transition-all duration-300 text-lg"
                        placeholder="Cuéntanos sobre tu negocio y necesidades"
                      ></textarea>
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className={`w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-8 py-4 rounded-xl transition-all duration-300 font-bold text-lg shadow-2xl hover:shadow-3xl transform hover:scale-105 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
                    >
                      {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
                    </button>
                  </form>
                </div>
              </div>
            </section>
          </main>

          {/* FOOTER ACTUALIZADO (REEMPLAZAR BLOQUE) */}
          <footer className="bg-gradient-to-r from-gray-800 to-gray-900 text-white py-16 relative overflow-hidden">
            <div className="absolute inset-0 opacity-20 pointer-events-none">
              <div className="absolute top-10 left-10 w-20 h-20 bg-pink-400 rounded-full blur-xl"></div>
              <div className="absolute bottom-10 right-10 w-24 h-24 bg-purple-400 rounded-full blur-xl"></div>
            </div>

            <div className="container mx-auto px-4 relative z-10">
              <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
                {/* Left: logo + descripción + correos con banderas (SVGs) */}
                <div className="flex-1 min-w-[260px]">
                  <div className="flex items-center space-x-3 mb-4">
                    <img src={Logo} alt="Logo Distri Dulces" className="w-12 h-12 object-contain drop-shadow-[0_0_6px_rgba(255,255,255,0.6)]" />
                    <h2 className="text-2xl text-white" style={{ fontFamily: "'Lemongrass Script', cursive" }}>Distri Dulces™</h2>
                  </div>
                  <p className="text-gray-300 max-w-md text-lg mb-4">
                    Distribuidora mayorista. Somos representantes de marcas® nacionales y extranjeras.
                  </p>

                  {/* Correos con banderas SVG */}
                  <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6 gap-3 mt-3">
                    <a href="mailto:distridulcesargentina@gmail.com" className="inline-flex items-center gap-3 text-gray-100 hover:text-white transition-colors" aria-label="Enviar email a DistriDulces Argentina">
                      {/* Argentina SVG */}
                      <svg width="28" height="20" viewBox="0 0 512 512" aria-hidden focusable="false" xmlns="http://www.w3.org/2000/svg">
                        <rect width="512" height="512" fill="#73B2E6" />
                        <rect y="170" width="512" height="172" fill="#fff" />
                        <rect y="341" width="512" height="171" fill="#73B2E6" />
                        {/* Sol simple */}
                        <circle cx="256" cy="256" r="40" fill="#FFD66B" />
                        <circle cx="256" cy="256" r="22" fill="#fff" />
                      </svg>
                      <span className="text-sm">distridulcesargentina@gmail.com</span>
                    </a>

                    <a href="mailto:ddistridulces@gmail.com" className="inline-flex items-center gap-3 text-gray-100 hover:text-white transition-colors" aria-label="Enviar email a DistriDulces Bolivia">
                      {/* Bolivia SVG */}
                      <svg width="28" height="20" viewBox="0 0 512 512" aria-hidden focusable="false" xmlns="http://www.w3.org/2000/svg">
                        <rect width="512" height="512" fill="#D52B1E" />
                        <rect y="170" width="512" height="172" fill="#FFD100" />
                        <rect y="341" width="512" height="171" fill="#007A3D" />
                      </svg>
                      <span className="text-sm">ddistridulces@gmail.com</span>
                    </a>
                  </div>
                </div>

                {/* Center: mapa (embed) - interactivo en todos los dispositivos */}
                <div className="flex-1 w-full max-w-lg mx-auto lg:mx-0">
                  <div className="bg-white rounded-xl overflow-hidden shadow-2xl">
                    <div className="px-4 py-3 border-b border-gray-100">
                      <p className="text-gray-700 font-semibold">Nuestra ubicación</p>
                    </div>

                    <div className="w-full h-56 sm:h-64 md:h-56 lg:h-48 map-wrapper">
                      <iframe
                        title="Ubicación San Miguel de Tucumán"
                        src="https://www.google.com/maps?q=-26.8328719,-65.195247&z=15&output=embed"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        allow="geolocation; clipboard-write; encrypted-media; fullscreen; autoplay"
                        className="map-iframe"
                        referrerPolicy="no-referrer-when-downgrade"
                      />
                    </div>

                    <div className="px-4 py-3 bg-gray-50">
                      <p className="text-sm text-gray-600">El Bajo - Tucumán - Zona Comercial | Av. Benjamín Araoz 120 - Galería La Florida</p>
                    </div>
                  </div>
                </div>

                {/* Right: redes sociales (Facebook, Instagram, TikTok oficial SVG) */}
                <div className="flex-1 min-w-[160px] flex flex-col items-center lg:items-end gap-4">
                  <div className="flex space-x-4">
                    <a href="https://www.facebook.com/distridulces.arg" className="bg-gray-700 hover:bg-purple-600 p-3 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-110" aria-label="Facebook" title="Facebook" target="_blank" rel="noreferrer">
                      <Facebook className="w-6 h-6 text-white" />
                    </a>

                    <a href="https://www.instagram.com/distridulces.arg/" className="bg-gray-700 hover:bg-pink-600 p-3 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-110" aria-label="Instagram" title="Instagram" target="_blank" rel="noreferrer">
                      <Instagram className="w-6 h-6 text-white" />
                    </a>
                    {/* TikTok button: mismo estilo que los demás */}
                    <a
                      href="https://www.tiktok.com/@distridulcesarg"
                      className="bg-gray-700 hover:bg-black p-3 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-110 flex items-center justify-center"
                      aria-label="TikTok"
                      title="TikTok"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <SiTiktok className="w-6 h-6 text-white" />
                    </a>
                  </div>

                  <p className="text-gray-400 text-sm mt-2 text-center lg:text-right">
                    Síguenos en redes para más novedades y promociones.
                  </p>
                </div>
              </div>

              <div className="mt-12 pt-8 border-t border-gray-700 text-center text-gray-400">
                <p className="text-lg">&copy; {new Date().getFullYear()} Desarrollado por <a href="https://synergydev.com.ar" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 transition-colors duration-200">Synergy Dev.</a> Todos los derechos reservados.</p>
              </div>
            </div>
          </footer>

          <a
            href="https://wa.me/5493813528236"
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-8 right-8 z-[60] p-2 rounded-full shadow-2xl hover:scale-110 transition-all duration-300 group flex items-center justify-center animate-bounce-slow"
            aria-label="Contactar por WhatsApp"
          >
            <img
              src={MascIcon}
              alt="Mascota WhatsApp"
              className="w-16 h-16 md:w-20 md:h-20 object-contain group-hover:rotate-12 transition-transform duration-300 drop-shadow-[0_10px_15px_rgba(0,0,0,0.15)]"
            />
            <span className="absolute bottom-full mb-4 left-1/2 -translate-x-1/2 bg-white text-gray-800 px-4 py-2 rounded-xl text-sm font-bold shadow-xl opacity-0 group-hover:opacity-100 transition-all duration-300 whitespace-nowrap pointer-events-none transform translate-y-2 group-hover:translate-y-0">
              ¡Hola! ¿En qué <br /> podemos ayudarte?
              <div className="absolute top-full left-1/2 -translate-x-1/2 border-8 border-transparent border-t-white"></div>
            </span>
          </a>

          <style>{`
        @keyframes bounce-slow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .animate-bounce-slow {
          animation: bounce-slow 3s ease-in-out infinite;
        }
      `}</style>
        </div>
      )}
      <ClubJoinModal isOpen={isClubModalOpen} onClose={() => setIsClubModalOpen(false)} type={clubModalType} />
    </>
  );
};

const ClubJoinButton = ({ onClick, text = "¡Quiero unirme al Club!" }) => (
  <button
    onClick={onClick}
    className="px-8 py-4 rounded-full bg-white text-purple-600 font-extrabold shadow-[0_10px_30px_rgba(0,0,0,0.15)] hover:shadow-[0_20px_40px_rgba(0,0,0,0.2)] hover:scale-110 transition-all duration-300 border-2 border-purple-100"
  >
    {text}
  </button>
);

const ClubJoinModal = ({ isOpen, onClose, type }) => {
  const [formData, setFormData] = useState({ name: '', business: '', email: '', phone: '', address: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [errors, setErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showPredictions, setShowPredictions] = useState(false);

  // useEffect for address autocomplete debate
  useEffect(() => {
    const fetchAddresses = async () => {
      if (searchQuery.trim().length < 3) {
        setSearchResults([]);
        return;
      }
      setIsSearching(true);
      try {
        // Query param countrycodes removed as per user request to include neighboring countries
        const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(searchQuery)}&addressdetails=1&limit=5`, {
          headers: {
            'Accept-Language': 'es' // Request results in Spanish
          }
        });
        const data = await response.json();
        setSearchResults(data);
      } catch (error) {
        console.error("Error fetching addresses:", error);
      } finally {
        setIsSearching(false);
      }
    };

    const debounceTimer = setTimeout(fetchAddresses, 500);
    return () => clearTimeout(debounceTimer);
  }, [searchQuery]);

  const handleAddressSelect = (address) => {
    setFormData(prev => ({ ...prev, address: address.display_name }));
    setSearchQuery(address.display_name);
    setShowPredictions(false);
    if (errors.address) setErrors(prev => ({ ...prev, address: '' }));
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'El nombre es obligatorio';
    if (!formData.business.trim()) newErrors.business = 'El nombre del negocio es obligatorio';
    if (!formData.email.trim() || !/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email inválido';
    if (!formData.phone.trim()) newErrors.phone = 'El WhatsApp es obligatorio';
    if (!formData.address.trim()) newErrors.address = 'La dirección es obligatoria';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      const typeLabel = type === 'mayorista' ? 'MAYORISTA' : 'KIOSCO';
      const message = `*Nueva solicitud cliente Distridulces (${typeLabel})*%0A%0A*Nombre:* ${formData.name}%0A*Negocio:* ${formData.business}%0A*Email:* ${formData.email}%0A*WhatsApp:* ${formData.phone}%0A*Dirección:* ${formData.address}`;
      window.open(`https://wa.me/5493813528236?text=${message}`, '_blank');
      setSubmitSuccess(true);
      setTimeout(() => {
        onClose();
        setSubmitSuccess(false);
        setFormData({ name: '', business: '', email: '', phone: '', address: '' });
        setSearchQuery('');
      }, 3000);
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-6"
        >
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => !isSubmitting && onClose()} />
          <motion.div
            initial={{ y: 50, opacity: 0, scale: 0.95 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: 50, opacity: 0, scale: 0.95 }}
            className="relative bg-white rounded-[2rem] w-full max-w-lg md:max-w-2xl max-h-[90vh] flex flex-col shadow-2xl overflow-hidden border border-white/20"
          >
            {/* Header */}
            <div className="p-6 md:p-8 border-b border-gray-100 flex justify-between items-start shrink-0 bg-white z-10">
              <div>
                <h3 className="text-2xl md:text-3xl font-black text-blue-700 leading-tight">
                  {type === 'mayorista' ? 'Unite a la Familia Mayorista' : 'Unite al Club DistriDulces'}
                </h3>
                <p className="text-sm md:text-base text-gray-500 mt-1">
                  Obtené beneficios exclusivos para tu {type === 'mayorista' ? 'distribuidora' : 'negocio'}.
                </p>
              </div>
              <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
                <X className="w-6 h-6 text-gray-400" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-6 md:p-8 custom-scrollbar">
              {submitSuccess ? (
                <div className="py-10 text-center bg-green-50 rounded-3xl">
                  <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Heart className="w-8 h-8 text-green-600 fill-current" />
                  </motion.div>
                  <h4 className="text-2xl font-black text-green-600 mb-2">¡Solicitud Enviada!</h4>
                  <p className="text-green-700">Gracias por tu interés. Nos pondremos en contacto pronto.</p>
                </div>
              ) : (
                <form id="club-form-global" onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-1">
                      <label className="text-xs font-bold text-gray-600 uppercase tracking-wider">Nombre Completo</label>
                      <input
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Tu nombre y apellido"
                        className={`w-full px-4 py-3 border-2 rounded-xl focus:ring-2 focus:ring-blue-100 focus:border-blue-500 transition-all outline-none text-sm ${errors.name ? 'border-red-400' : 'border-gray-100 bg-gray-50'}`}
                      />
                      {errors.name && <p className="text-red-500 text-xs">{errors.name}</p>}
                    </div>
                    <div className="space-y-1">
                      <label className="text-xs font-bold text-gray-600 uppercase tracking-wider">Tu Negocio</label>
                      <input
                        name="business"
                        value={formData.business}
                        onChange={handleInputChange}
                        placeholder="Nombre comercial"
                        className={`w-full px-4 py-3 border-2 rounded-xl focus:ring-2 focus:ring-blue-100 focus:border-blue-500 transition-all outline-none text-sm ${errors.business ? 'border-red-400' : 'border-gray-100 bg-gray-50'}`}
                      />
                      {errors.business && <p className="text-red-500 text-xs">{errors.business}</p>}
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-1">
                      <label className="text-xs font-bold text-gray-600 uppercase tracking-wider">Email</label>
                      <input
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="ejemplo@correo.com"
                        className={`w-full px-4 py-3 border-2 rounded-xl focus:ring-2 focus:ring-blue-100 focus:border-blue-500 transition-all outline-none text-sm ${errors.email ? 'border-red-400' : 'border-gray-100 bg-gray-50'}`}
                      />
                      {errors.email && <p className="text-red-500 text-xs">{errors.email}</p>}
                    </div>
                    <div className="space-y-1">
                      <label className="text-xs font-bold text-gray-600 uppercase tracking-wider">WhatsApp</label>
                      <input
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        placeholder="+54 9 381 ..."
                        className={`w-full px-4 py-3 border-2 rounded-xl focus:ring-2 focus:ring-blue-100 focus:border-blue-500 transition-all outline-none text-sm ${errors.phone ? 'border-red-400' : 'border-gray-100 bg-gray-50'}`}
                      />
                      {errors.phone && <p className="text-red-500 text-xs">{errors.phone}</p>}
                    </div>
                  </div>

                  {/* Address Field with Autocomplete */}
                  <div className="space-y-1 relative">
                    <label className="text-xs font-bold text-gray-600 uppercase tracking-wider">Dirección de Envío / Local</label>
                    <div className="relative">
                      <Pin className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5 pointer-events-none" />
                      <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => {
                          setSearchQuery(e.target.value);
                          setFormData(prev => ({ ...prev, address: e.target.value }));
                          setShowPredictions(true);
                          if (errors.address) setErrors(prev => ({ ...prev, address: '' }));
                        }}
                        onFocus={() => setShowPredictions(true)}
                        placeholder="Empezá a escribir para buscar tu dirección..."
                        className={`w-full pl-10 pr-4 py-3 border-2 rounded-xl focus:ring-2 focus:ring-blue-100 focus:border-blue-500 transition-all outline-none text-sm ${errors.address ? 'border-red-400' : 'border-gray-100 bg-gray-50'}`}
                        autoComplete="off"
                      />
                      {isSearching && (
                        <div className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                      )}
                    </div>
                    {errors.address && <p className="text-red-500 text-xs">{errors.address}</p>}

                    {/* Autocomplete Predictions Dropdown */}
                    <AnimatePresence>
                      {showPredictions && searchResults.length > 0 && (
                        <motion.ul
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -10 }}
                          className="absolute z-50 w-full bg-white mt-1 border border-gray-100 rounded-xl shadow-2xl max-h-60 overflow-y-auto divide-y divide-gray-50 custom-scrollbar"
                        >
                          {searchResults.map((result) => (
                            <li
                              key={result.place_id}
                              onClick={() => handleAddressSelect(result)}
                              className="px-4 py-3 hover:bg-blue-50 text-sm text-gray-700 cursor-pointer transition-colors flex items-start gap-2"
                            >
                              <Pin className="w-4 h-4 text-gray-400 shrink-0 mt-0.5" />
                              <span className="leading-tight">{result.display_name}</span>
                            </li>
                          ))}
                        </motion.ul>
                      )}
                    </AnimatePresence>
                  </div>
                </form>
              )}
            </div>

            {/* Footer */}
            {!submitSuccess && (
              <div className="shrink-0 p-4 md:p-6 border-t border-gray-100 bg-gray-50 flex gap-3">
                <button
                  type="button"
                  onClick={onClose}
                  disabled={isSubmitting}
                  className="flex-1 py-3 rounded-xl border-2 border-gray-100 text-gray-500 hover:bg-gray-100 transition font-bold text-sm uppercase tracking-wider"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  form="club-form-global"
                  disabled={isSubmitting}
                  className={`flex-[2] px-6 py-3 rounded-xl bg-gradient-to-r from-pink-500 to-pink-600 text-white font-bold shadow-md transition-all text-sm uppercase tracking-wider ${isSubmitting ? 'opacity-70 cursor-not-allowed' : 'hover:scale-[1.01] active:scale-[0.98]'}`}
                >
                  {isSubmitting ? 'Enviando...' : '¡Enviar Solicitud!'}
                </button>
              </div>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

const ComingSoonView = ({ onBack }) => (
  <div className="min-h-screen bg-gradient-to-br from-pink-400 via-purple-500 to-pink-600 flex items-center justify-center p-4 relative overflow-hidden">
    <div className="absolute inset-0 opacity-20">
      <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full translate-x-1/2 translate-y-1/2 blur-3xl"></div>
    </div>

    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-2xl w-full bg-white/10 backdrop-blur-xl rounded-3xl p-8 md:p-12 shadow-2xl border border-white/20 text-center relative z-10"
    >
      <div className="mb-8 flex justify-center">
        <div className="p-6 bg-white/20 rounded-full animate-bounce">
          <ShoppingCart className="w-16 h-16 text-white" />
        </div>
      </div>

      <h2 className="text-5xl md:text-7xl text-white mb-6 pb-4" style={{ fontFamily: "'Lemongrass Script', cursive", lineHeight: 1.4 }}>
        Próximamente...
      </h2>

      <p className="text-xl md:text-2xl text-white/90 mb-10 font-medium">
        Estamos preparando una experiencia dulce única para ti. Muy pronto podrás acceder a nuestra tienda online completa.
      </p>

      <div className="space-y-4">
        <div className="h-2 bg-white/20 rounded-full overflow-hidden">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: '75%' }}
            transition={{ duration: 2, ease: "easeOut" }}
            className="h-full bg-gradient-to-r from-pink-300 to-purple-300"
          />
        </div>
        <p className="text-white/70 text-sm">Progreso de la tienda: 75% completado</p>
      </div>

      <button
        onClick={onBack}
        className="mt-12 bg-white text-purple-600 hover:bg-pink-50 px-8 py-3 rounded-full font-bold text-lg transition-all shadow-xl hover:scale-105"
      >
        Volver al Inicio
      </button>
    </motion.div>
  </div>
);

const ClubBenefitsView = ({ type, onBack, onJoinClick }) => {
  const isKiosco = type === 'kiosco';

  const benefits = isKiosco ? [
    { title: 'Combos Kiosqueros', desc: 'Armamos paquetes de productos con el mejor margen para que tu kiosco rinda más.', icon: <Star className="text-yellow-400" /> },
    { title: 'Novedades Semanales', desc: 'Sé el primero en tener los lanzamientos de las mejores marcas en tu zona.', icon: <Candy className="text-pink-500" /> },
    { title: 'Pedidos Simplificados', desc: 'Hacé tu pedido por WhatsApp y recibilo en la puerta de tu local rápido y fácil.', icon: <MessageCircle className="text-green-500" /> }
  ] : [
    { title: 'Precios Ganadores', desc: 'Accedé a la mejor lista de precios de la región para maximizar tu volumen.', icon: <Star className="text-yellow-400" /> },
    { title: 'Stock Asegurado', desc: 'Garantizamos disponibilidad de productos críticos para tu distribución mayorista.', icon: <Candy className="text-pink-500" /> },
    { title: 'Atención Corporativa', desc: 'Un ejecutivo de cuentas dedicado gestionará tus necesidades de gran escala.', icon: <MessageCircle className="text-green-500" /> }
  ];

  return (
    <div className={`min-h-screen ${isKiosco ? 'bg-white' : 'bg-slate-50'}`}>
      {/* Mini Header */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md shadow-sm">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <h2 className={`text-2xl font-bold ${isKiosco ? 'text-purple-600' : 'text-indigo-600'}`} style={{ fontFamily: "'Lemongrass Script', cursive" }}>Distri Dulces™</h2>
          <button onClick={onBack} className="text-gray-600 hover:text-purple-600 font-bold flex items-center gap-2">
            <ChevronLeft size={20} /> Volver
          </button>
        </div>
      </nav>

      <main className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <motion.span
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className={`inline-block px-4 py-1 rounded-full text-sm font-bold mb-4 ${isKiosco ? 'bg-pink-100 text-pink-600' : 'bg-indigo-100 text-indigo-600'}`}
            >
              EXCLUSIVO PARA {isKiosco ? 'KIOSCOS' : 'MAYORISTAS'}
            </motion.span>
            <motion.h1
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              className="text-5xl md:text-7xl font-extrabold text-gray-900 mb-6 leading-[1.1] tracking-tight"
            >
              Potenciá tu {isKiosco ? 'negocio' : 'distribución'} con {isKiosco ? 'el' : 'la'} <span className={`inline-block pb-4 text-transparent bg-clip-text bg-gradient-to-r ${isKiosco ? 'from-pink-500 to-purple-600' : 'from-[#8A7CC7] to-[#FF8BB2]'} drop-shadow-sm`} style={{ fontFamily: "'Lemongrass Script', cursive" }}>{isKiosco ? 'Club DistriDulces' : 'Familia Mayorista'}</span>
            </motion.h1>
            <p className="text-xl md:text-2xl text-gray-500 font-medium max-w-3xl mx-auto leading-relaxed">
              {isKiosco
                ? 'Diseñamos este espacio pensando en el crecimiento de tu comercio. Accedé a beneficios que nadie más tiene.'
                : 'Soluciones de gran escala para distribuidores que buscan liderar su mercado. Rentabilidad y respaldo garantizado.'}
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-20">
            {benefits.map((benefit, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                className={`group bg-white p-10 rounded-[2.5rem] border border-gray-100 shadow-[0_20px_50px_rgba(0,0,0,0.04)] hover:shadow-[0_40px_80px_rgba(147,51,234,0.1)] transition-all duration-500 relative overflow-hidden`}
              >
                <div className={`absolute top-0 right-0 w-24 h-24 bg-gradient-to-br ${isKiosco ? 'from-purple-50 to-pink-50' : 'from-[#FDB5A5] to-[#C5B9F3]'} rounded-bl-[4rem] -z-10 transition-transform group-hover:scale-150 duration-700`} />

                <div className="w-16 h-16 bg-white rounded-2xl shadow-md flex items-center justify-center mb-8 transform group-hover:rotate-6 transition-transform duration-300 border border-gray-50">
                  {benefit.icon}
                </div>

                <h3 className={`text-2xl md:text-3xl font-extrabold text-gray-900 mb-5 leading-tight tracking-tight group-hover:${isKiosco ? 'text-purple-600' : 'text-[#8A7CC7]'} transition-colors duration-300`}>
                  {benefit.title}
                </h3>

                <p className="text-gray-500 text-lg leading-relaxed font-medium group-hover:text-gray-600 transition-colors duration-300">
                  {benefit.desc}
                </p>

                <div className={`mt-8 flex items-center gap-2 ${isKiosco ? 'text-purple-600' : 'text-[#8A7CC7]'} font-bold opacity-0 group-hover:opacity-100 transform translate-x-[-10px] group-hover:translate-x-0 transition-all duration-300`}>
                  <a href={`https://wa.me/5493813528236?text=Hola! Quiero saber más sobre los beneficios para ${isKiosco ? 'Kioscos' : 'Mayoristas'}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                    Saber más <ChevronRight size={18} />
                  </a>
                </div>
              </motion.div>
            ))}
          </div>

          <div className={`bg-gradient-to-br ${isKiosco ? 'from-purple-600 to-pink-600' : 'from-[#8A7CC7] to-[#7466B1]'} rounded-[3rem] p-8 md:p-16 text-center text-white relative overflow-hidden shadow-2xl`}>
            <div className="absolute top-0 right-0 p-12 opacity-10 rotate-12">
              <Candy size={160} />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-8">¿Listo para dar el siguiente paso?</h2>
            <p className="text-xl mb-10 text-white/90 max-w-2xl mx-auto">
              Sumate gratis hoy mismo y empezá a disfrutar de los beneficios de ser parte de nuestra familia.
            </p>
            <button
              onClick={onJoinClick}
              className={`px-8 py-4 rounded-full bg-white ${isKiosco ? 'text-purple-600' : 'text-[#8A7CC7]'} font-extrabold shadow-xl hover:scale-110 transition-all duration-300`}
            >
              ¡Quiero unirme!
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

const NuestroEquipoView = ({ onBack }) => {
  const leadership = [
    { name: 'Mica Rodríguez', role: 'Directora Administrativa', image: StaffMicaR, accent: 'from-purple-500 to-indigo-500' },
    { name: 'Stella Barros', role: 'Supervisora General', image: StaffStella, accent: 'from-pink-500 to-rose-500' },
    { name: 'Guillermo Diaz Bueno', role: 'Asesor Comercial Mayorista', image: StaffGuillermo, accent: 'from-indigo-500 to-purple-500' },
  ];

  const team = [
    { name: 'Exe Contreras', role: 'Asesor Comercial', image: StaffExe, accent: 'from-pink-400 to-indigo-400', zones: ['Monteros', 'Famaillá', 'Lules'] },
    { name: 'Agus Quipildor', role: 'Asesora Comercial', image: StaffAgus, accent: 'from-pink-400 to-purple-400', zones: ['Alderetes', 'San Miguel de Tucumán (circuito norte)'] },
    { name: 'Mica Olea', role: 'Asesora Comercial', image: StaffMicaO, accent: 'from-purple-400 to-rose-400', zones: ['Termas del Río Hondo', 'Aguilares'] },
    { name: 'Nadia González', role: 'Asesora Comercial', image: StaffNadia, accent: 'from-rose-400 to-purple-400', zones: ['Las Talitas', 'Tafí Viejo', 'Banda del Río Salí'] },
    { name: 'Erasmo Castillo', role: 'Asesor Comercial', image: StaffErasmo, accent: 'from-indigo-400 to-pink-400', zones: ['Termas del Río Hondo', 'Aguilares', 'Santa Ana', 'Río Chico'] },
    { name: 'Davor Platero', role: 'Asesor Comercial', image: StaffDavor, accent: 'from-purple-400 to-pink-400', zones: ['Yerba Buena', 'Alderetes', 'San Miguel de Tucumán (circuito norte)'] },
    { name: 'Yuli Contreras', role: 'Asesora Comercial', image: StaffYuli, accent: 'from-pink-400 to-purple-500', zones: ['Manantial', 'San Pablo', 'Acheral', 'Santa Lucia', 'San Miguel Sur'] },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-pink-50/30 font-sans">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md shadow-sm">
        <div className="container mx-auto px-4 py-4 max-w-6xl flex justify-between items-center">
          <div className="flex items-center space-x-3 group cursor-pointer" onClick={onBack}>
            <div className="bg-gray-100 group-hover:bg-purple-100 p-2 rounded-full transition-all duration-300">
              <ChevronLeft className="w-6 h-6 text-gray-600 group-hover:text-purple-600" />
            </div>
            <h2 className="text-2xl text-purple-600" style={{ fontFamily: "'Lemongrass Script', cursive" }}>Distri Dulces™</h2>
          </div>
        </div>
      </header>

      <main className="pt-28 pb-20">
        <div className="container mx-auto px-4 max-w-6xl">
          {/* Hero */}
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-20">
            <span className="inline-block px-5 py-2 bg-gradient-to-r from-pink-100 to-purple-100 text-purple-600 rounded-full text-sm font-bold mb-6 tracking-widest uppercase">
              Conocenos
            </span>
            <h1 className="text-5xl md:text-7xl font-extrabold text-gray-900 mb-6 tracking-tight leading-[1.1]">
              Nuestro <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-600 pb-2" style={{ fontFamily: "'Lemongrass Script', cursive" }}>Equipo</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-500 max-w-3xl mx-auto leading-relaxed">
              Detrás de cada dulce hay personas apasionadas que trabajan para llevar alegría a tu negocio.
            </p>
          </motion.div>

          {/* Leadership */}
          <div className="mb-20">
            <h3 className="text-center text-sm font-bold text-purple-500 uppercase tracking-[0.2em] mb-10">Dirección</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-4xl mx-auto">
              {leadership.map((member, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.15 }}
                  className="group"
                >
                  <div className="bg-white rounded-[2rem] overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100">
                    <div className="relative h-72 overflow-hidden">
                      <img src={member.image} alt={member.name} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700" />
                      <div className={`absolute inset-0 bg-gradient-to-t ${member.accent} opacity-0 group-hover:opacity-20 transition-opacity duration-500`} />
                    </div>
                    <div className="p-6 text-center">
                      <h4 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h4>
                      <p className="text-purple-500 font-semibold text-sm">{member.role}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Commercial Team */}
          <div className="mb-20">
            <h3 className="text-center text-sm font-bold text-pink-500 uppercase tracking-[0.2em] mb-10">Equipo Comercial</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {team.map((member, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.07 }}
                  className="group"
                >
                  <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 border border-gray-100 h-full flex flex-col">
                    <div className="relative h-52 sm:h-60 overflow-hidden shrink-0">
                      <img src={member.image} alt={member.name} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700" />
                      <div className={`absolute inset-0 bg-gradient-to-t ${member.accent} opacity-0 group-hover:opacity-20 transition-opacity duration-500`} />
                    </div>
                    <div className="p-4 text-center flex-1 flex flex-col">
                      <h4 className="text-base font-bold text-gray-900 mb-0.5">{member.name}</h4>
                      <p className="text-pink-500 font-medium text-xs mb-3">{member.role}</p>
                      {member.zones && member.zones.length > 0 && (
                        <div>
                          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-2">Representante oficial de:</p>
                          <div className="flex flex-wrap justify-center gap-1.5">
                            {member.zones.map((zone, zi) => (
                              <span
                                key={zi}
                                className="inline-block px-2.5 py-1 bg-gradient-to-r from-pink-50 to-purple-50 text-purple-600 rounded-full text-[10px] font-semibold border border-purple-100/50"
                              >
                                📍 {zone}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 rounded-[3rem] p-10 md:p-16 text-center text-white relative overflow-hidden shadow-2xl"
          >
            <div className="absolute top-0 right-0 p-8 opacity-10">
              <Users size={120} />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">¿Querés ser parte del equipo?</h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Sumate a la familia Distri Dulces y crecé con nosotros.
            </p>
            <a
              href="https://wa.me/5493813528236?text=Hola! Me interesa trabajar en Distri Dulces."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-10 py-4 bg-white text-purple-600 rounded-full font-bold text-lg shadow-xl hover:scale-105 transition-all duration-300"
            >
              Contactanos
            </a>
          </motion.div>
        </div>
      </main>
    </div>
  );
};


export default App;
